import { CerFormAdapter } from '@cer/cer-form/cer-form-adapter';
import { CerFormViewSet } from '@cer/cer-form/cer-form-view-set';
import { CerFormView } from '@cer/cer-form/cer-form-view';

// App
import { SalesOrderService } from './sales-order.service';
import { WarehouseOutboundOrderService, orderPanes, orderWarehouseOutboundOrderPanes } from '../warehousing/warehouse-outbound-order.service';
import { CerAppDataNoteService } from 'src/cer-app/cer-app-data-note/cer-app-data-note.service';

export class SalesOrderForm extends CerFormAdapter {

  public override viewSetInit(viewSet: CerFormViewSet): void {
    const params = this.routeOptions.routeParams ?? [];
    const isNew = params.includes("$statusGroup=New");
    //const isPlanning = params.includes("$statusGroup=Planning");
    //const isRemain = params.includes("$statusGroup=Remain");
    //const isDelivered = params.includes("$statusGroup=Delivered");
    const isCaptureReady = params.includes("$statusGroup=CaptureReady");
    const isInvoiceCreditReady = params.includes("$statusGroup=InvoiceCreditReady");
    //const isCaptured = params.includes("$statusGroup=Captured");
    //const isInvoiced = params.includes("$statusGroup=Invoiced");
    //const isCompleted = params.includes("$statusGroup=Completed");
    //const isCancelled = params.includes("$statusGroup=Cancelled");

    viewSet.panes = isNew ? orderPanes : orderWarehouseOutboundOrderPanes;

    const salesOrderService = this.context.injector.get(SalesOrderService);
    const salesOrderView = this.salesOrderViewGet(salesOrderService, isCaptureReady, isInvoiceCreditReady);
    salesOrderView.viewMetadata.dataApiParams = params;
    salesOrderView.paneTarget = isNew ? 'main' : 'top';
    const salesOrderLineView = this.salesOrderLineViewGet(salesOrderService);
    salesOrderLineView.paneTarget = 'bottom';
    salesOrderLineView.mandatory = true;

    viewSet.viewAdd(salesOrderView);
    viewSet.viewAdd(salesOrderLineView, salesOrderView);

    const dataNoteView = this.dataNoteViewGet();
    dataNoteView.paneTarget = isNew ? 'bottomRight': 'main';
    dataNoteView.mandatory = true;
    viewSet.viewAdd(dataNoteView, salesOrderView);

    if (!isNew) {
      const outboundOrderService = this.context.injector.get(WarehouseOutboundOrderService);

      const outboundOrderView = this.outboundOrderViewGet(outboundOrderService);
      outboundOrderView.paneTarget =  'right';
      outboundOrderView.mandatory = true;
      const outboundOrderLineView = this.outboundOrderLineViewGet(outboundOrderService);
      outboundOrderLineView.paneTarget = 'bottomRight';
      outboundOrderLineView.mandatory = true;

      viewSet.viewAdd(outboundOrderView, salesOrderView);
      viewSet.viewAdd(outboundOrderLineView, outboundOrderView);
    }

  }

  private salesOrderViewGet(svc: SalesOrderService, isCaptureReady: boolean, isInvoiceCreditReady: boolean): CerFormView {
    const v = new CerFormView({
      viewMetadata: svc.salesOrderViewMetadata,
      listSelectionMode: 'row',
      toolbarCommands: svc.orderToolbarCommandsGet(isCaptureReady, isInvoiceCreditReady),
      contextMenuCommands: svc.orderContextMenuCommandsGet(isCaptureReady, isInvoiceCreditReady),
      fieldMetadata: [...svc.salesOrderFieldMetadata],
      fieldGroupMetadata: svc.salesOrderFieldGroupMetadata,
      onCommandEvent: (e => svc.onCommand(e))
    });
    if (isCaptureReady) {
      v.fieldMetadata.filter(f => { f.name == 'custVATNum' || f.name == 'custEAN' }).forEach(f => f.visible = false);
      v.listSelectionMode = 'checkboxMulti';
    }
    if (isInvoiceCreditReady) {
      v.fieldMetadata.filter(f => f.name == 'paymentReference').forEach(f => f.visible = false);
      v.listSelectionMode = 'checkboxMulti';
    }
    return v;
  }

  private salesOrderLineViewGet(svc: SalesOrderService): CerFormView {
    return new CerFormView({
      viewMetadata: svc.salesLineViewMetadata,
      fieldMetadata: svc.salesLineFieldMetadata
    });
  }

  private outboundOrderViewGet(svc: WarehouseOutboundOrderService): CerFormView {
    return new CerFormView({
      viewMetadata: svc.orderViewMetadata,
      fieldMetadata: svc.orderFieldMetadata,
      fieldGroupMetadata: svc.orderFieldGroupMetadata,
      toolbarCommands: svc.orderToolbarSimpleCommands,
      contextMenuCommands: svc.orderContextMenuCommands,
      onCommandEvent: (e => svc.onCommand(e))
    });
  }

  private outboundOrderLineViewGet(svc: WarehouseOutboundOrderService): CerFormView {
    return new CerFormView({
      viewMetadata: svc.orderLineViewMetadata,
      fieldMetadata: svc.orderLineFieldMetadata
    });
  }

  private dataNoteViewGet(): CerFormView {
    const svc = this.context.injector.get(CerAppDataNoteService);
    const dataNoteTables: string[] = ['SalesOrder', 'WarehouseOutboundOrder'];
    return new CerFormView({
      viewMetadata: svc.viewMetadataGet(dataNoteTables),
      fieldMetadata: svc.fieldMetadataGet(dataNoteTables[0])
    });
  }
}
